module.exports = __webpack_public_path__ + "img/reports.5ee0eaf2.svg";